import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import axios from "axios";
import { CustomSelect, postData } from "../Commonfunction/CommonFunction";
import FileUpload from "../common/FileUpload";
import PhoneInput from "react-phone-input-2";
import { FaRegSave, FaSave } from "react-icons/fa";
import { HiSaveAs } from "react-icons/hi";

export default function Settings({ setTheme }) {
  const token = localStorage.getItem("token");
  const [initialValues, setInitialValues] = useState({});
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState(""); // "success", "error", etc.

  const themeDropdown1 = [
    {
      label: "Theme 1",
      value: "theme1",
    },
    {
      label: "Theme 2",
      value: "theme2",
    },
    {
      label: "Theme 3",
      value: "theme3",
    },
    {
      label: "Theme 4",
      value: "theme4",
    },
    {
      label: "Theme 5",
      value: "theme5",
    },
    {
      label: "Theme 6",
      value: "theme6",
    },
    {
      label: "Theme 7",
      value: "theme7",
    },
  ];

  const showAlert = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    
    // Auto dismiss alert after 5 seconds
    setTimeout(() => {
      setAlertMessage("");
      setAlertType("");
    }, 5000);
  };

  const getAllSettings = () => {
    axios
      .get("/api/all-settings", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setInitialValues(response.data.data);
          setData(response.data.data);
        } else {
          showAlert(response.data.message, "error");
        }
      })
      .catch((error) => {
        showAlert("Failed to fetch settings", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = async (values) => {
    try {
      const request_url = "/api/save-settings";
      const postDataResult = await postData(request_url, values);
      showAlert(postDataResult.message, "success");
    } catch (error) {
      showAlert(error.response?.data?.message || "An error occurred", "error");
    }
  };

  useEffect(() => {
    getAllSettings();
  }, []);

  if (loading) {
    return (
      <div
        className="usa-section usa-section--light display-flex flex-column flex-align-center flex-justify-center"
        style={{ minHeight: "80vh" }}
      >
        <div className="usa-spinner" aria-label="Loading content"></div>
        <span className="margin-top-2">Loading...</span>
      </div>
    );
  }

  return (
    <div className="usa-section">
      {alertMessage && (
        <div className={`usa-alert usa-alert--${alertType}`} role="alert">
          <div className="usa-alert__body">
            <p className="usa-alert__text">{alertMessage}</p>
          </div>
        </div>
      )}

      <Formik
        initialValues={{
          site_title: data ? data.site_title : "",
          phone_num: data ? data.phone_num : "",
          email: data ? data.email : "",
          theme: data ? data.theme : "",
          site_logo: data ? data.site_logo : "",
          email_logo: data ? data.email_logo : "",
          favicon: data ? data.favicon : "",
          smtp_website_name: data ? data.smtp_website_name : "",
          smtp_server: data ? data.smtp_server : "",
          smtp_port: data ? data.smtp_port : "",
          smtp_email: data ? data.smtp_email : "",
          smtp_password: data ? data.smtp_password : "",
          smtp_from_name: data ? data.smtp_from_name : "",
          smtp_from_email: data ? data.smtp_from_email : "",
          smtp_driver: data ? data.smtp_driver : "",
          smtp_encryption: data ? data.smtp_encryption : "",
        }}
        onSubmit={(values) => {
          handleSubmit(values);
          setTheme(values.theme);
        }}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="modern-form-container">
            <div className="heading-wrapper">
              {/* <button
                  className="back-button"
                  onClick={() => navigate("/employees")}
                  title="Back to Employees"
                >
                  <IoArrowBack />
                </button> */}
              {/* <h2 className="form-heading">Site Settings</h2> */}
            </div>
            <div className="form-section">
              <h2 className="form-title"> Site Basic Settings :-</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="employeeType"> Name</label>
                  <Field
                    id="site_title"
                    className="form-control mb-2"
                    name="site_title"
                    type="text"
                    placeholder="Enter Site Title"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Field
                    id="email"
                    className="form-control mb-2"
                    name="email"
                    type="email"
                    placeholder="Enter Email Address"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone_num">Mobile Number</label>
                  <Field
                    id="phone_num"
                    className="form-control mb-2"
                    name="phone_num"
                    type="text"
                    placeholder="Enter Phone Number"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile_no">Mobile Number</label>
                  <PhoneInput
                    name="mobile_no"
                    country="us"
                    inputStyle={{ width: "100%" }}
                    inputProps={{ name: "mobile", required: true }}
                    value={values.mobile_no || ""}
                    onChange={(phone) => setFieldValue("mobile_no", phone)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="theme"> Select Theme</label>
                  <Field
                    name="theme"
                    component={CustomSelect}
                    options={themeDropdown1}
                    menuPosition="none"
                    style={{
                      color: "red",
                    }}
                  />
                  {setTheme(values.theme)}
                </div>

                <div className="form-group">
                  <label htmlFor="site_logo"> Site logo</label>
                  <Field name="site_logo">
                    {({ field }) => (
                      <FileUpload
                        setFieldValue={setFieldValue}
                        fieldName={"site_logo"}
                        areaText={"Upload Site Logo"}
                        imgUrl={values.site_logo}
                      />
                    )}
                  </Field>
                </div>

                <div className="form-group">
                  <label htmlFor="email_logo"> Email logo </label>
                  <Field name="email_logo">
                    {({ field }) => (
                      <FileUpload
                        setFieldValue={setFieldValue}
                        fieldName={"email_logo"}
                        areaText={"Upload Email Logo"}
                        imgUrl={values.email_logo}
                      />
                    )}
                  </Field>
                </div>

                <div className="form-group">
                  <label htmlFor="favicon"> Favicon</label>
                  <Field name="favicon">
                    {({ field }) => (
                      <FileUpload
                        setFieldValue={setFieldValue}
                        fieldName={"favicon"}
                        areaText={"Upload Favicon"}
                        imgUrl={values.favicon}
                      />
                    )}
                  </Field>
                </div>
              </div>
              <h2 className="form-title">SMTP Settings</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="employeeType"> SMTP Website Name</label>
                  <Field
                    id="smtp_website_name"
                    className="form-control mb-2"
                    name="smtp_website_name"
                    type="text"
                    placeholder="SMTP Website Name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">SMTP servere</label>
                  <Field
                    id="smtp_server"
                    className="form-control mb-2"
                    name="smtp_server"
                    type="text"
                    placeholder="SMTP Server"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone_num"> SMTP port</label>
                  <Field
                    id="smtp_port"
                    className="form-control mb-2"
                    name="smtp_port"
                    type="text"
                    placeholder="SMTP Port"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile_no"> SMTP Email</label>
                  <Field
                    id="smtp_email"
                    className="form-control mb-2"
                    name="smtp_email"
                    type="text"
                    placeholder="SMTP Email"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="smtp_password"> SMTP Password</label>
                  <Field
                    id="smtp_password"
                    className="form-control mb-2"
                    name="smtp_password"
                    type="password"
                    placeholder="SMTP Password"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="smtp_from_name"> SMTP From Name</label>
                  <Field
                    id="smtp_from_name"
                    className="form-control mb-2"
                    name="smtp_from_name"
                    type="text"
                    placeholder="SMTP From Name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email_logo"> SMTP From Email</label>
                  <Field
                    id="smtp_from_email"
                    className="form-control mb-2"
                    name="smtp_from_email"
                    type="text"
                    placeholder="SMTP From Email"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="favicon"> SMTP Driver</label>
                  <Field
                    id="smtp_driver"
                    className="form-control mb-2"
                    name="smtp_driver"
                    type="text"
                    placeholder="SMTP Driver"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="favicon"> SMTP Encryption</label>
                  <Field
                    id="smtp_encryption"
                    className="form-control mb-2"
                    name="smtp_encryption"
                    type="text"
                    placeholder="SMTP Encryption"
                  />
                </div>
              </div>
            </div>

            <div className="form-footer">
              <button type="submit" className="btn btn-submit">
                <FaSave /> Save Settings
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}